import React from "react";

const GolfCourseIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 18 22"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.6329,0.155v10.291l-12.9203,-5.152z"
        fill="#1A8B5A"
      />
      <path
        d="M14.2578,0v17.48h-1.25v-17.48z"
        fill="currentColor"
      />
      <path
        d="M16.9309,18c0,-0.275 -0.1345,-0.593 -0.4961,-0.941c-0.3627,-0.35 -0.9166,-0.69 -1.6454,-0.987c-1.4549,-0.593 -3.5022,-0.973 -5.7898,-0.973c-2.2874,0 -4.3341,0.38 -5.789,0.973c-0.7288,0.297 -1.2827,0.637 -1.6454,0.987c-0.3616,0.348 -0.4961,0.666 -0.4961,0.941c0,0.275 0.1343,0.594 0.4961,0.942c0.3627,0.35 0.9165,0.69 1.6454,0.987c1.4549,0.593 3.5016,0.972 5.789,0.972c2.2876,0 4.3349,-0.379 5.7898,-0.972c0.7289,-0.297 1.2827,-0.637 1.6454,-0.987c0.3618,-0.348 0.4961,-0.667 0.4961,-0.942zM18,18c0,0.678 -0.3395,1.268 -0.8344,1.744c-0.494,0.476 -1.1799,0.88 -1.9828,1.207c-1.609,0.656 -3.7956,1.049 -6.1832,1.049c-2.3875,0 -4.5735,-0.393 -6.1824,-1.049c-0.8028,-0.327 -1.4888,-0.731 -1.9828,-1.207c-0.4949,-0.476 -0.8344,-1.066 -0.8344,-1.744c0.0001,-0.678 0.3396,-1.267 0.8344,-1.744c0.494,-0.476 1.1799,-0.879 1.9828,-1.206c1.6089,-0.656 3.7948,-1.05 6.1824,-1.05c2.3877,0 4.5742,0.394 6.1832,1.05c0.8029,0.327 1.4888,0.73 1.9828,1.206c0.4948,0.477 0.8343,1.066 0.8344,1.744z"
        fill="currentColor"
      />
      <path
        d="M12.5612,18.494c1.217,0 2.2036,-0.512 2.2036,-1.144c0,-0.633 -0.9866,-1.145 -2.2036,-1.145c-1.217,0 -2.2035,0.512 -2.2035,1.145c0,0.632 0.9865,1.144 2.2035,1.144z"
        fill="currentColor"
      />
    </svg>
  );
};

export default GolfCourseIcon;
